import { FC } from "react";

type ChevronProps = {
    isOpen: boolean
}

const ChevronSmall: FC<ChevronProps> = ({ isOpen }) => {
    return (
        <>
            <svg
                className={`min-w-24px ${!isOpen ? "rotate-180" : "rotate-0"}`}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M9.97096 4.58654C10.2631 4.29436 10.2631 3.82064 9.97096 3.52846C9.67901 3.23651 9.20574 3.23625 8.91346 3.52788L6 6.435L3.08654 3.52788C2.79427 3.23625 2.32099 3.23651 2.02904 3.52846C1.73686 3.82064 1.73686 4.29436 2.02904 4.58654L4.58579 7.14329C5.36684 7.92434 6.63316 7.92433 7.41421 7.14329L9.97096 4.58654Z"
                    fill="black"
                />
            </svg>
        </>
    )
}

export default ChevronSmall;